import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { popPaperSelect, popPaperUpdate } from '../_stores/slice/popPaper';
import { CloseButton } from './';
import { Box, Popper, Fade, Hidden, Drawer, Dialog } from '@mui/material';


const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    '& .enter': {
      marginTop: 20,
      [theme.breakpoints.down('sm')]: {
        margin: '40px auto 30px auto',
      },
    },
    '&.Popper': {
      padding: '20px 50px 40px 50px',
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.borderRadius.large,
      boxShadow: theme.palette.shadow.total,
      backgroundColor: theme.palette.background.paper,
      [theme.breakpoints.down('sm')]: {
        padding: 20,
        width: '100%',
        border: 'none',
        borderTop: `1px solid ${theme.palette.line.main}`,
        borderRadius: 0,
        boxShadow: 'none',
      },
    },
    '&.Dialog': {
      padding: '20px 50px 40px 50px',
    },
    '&.Drawer': {
      paddingTop: 20,
      height: 'calc(90vh)',
      backgroundColor: theme.palette.background.paper,
      overflowX: 'hidden',
      '&>.content': {
        padding: '10px 20px 30px 20px',
      },
    },
  },
}));


const ContentBox = ({type, content, closeClick, scrollbar}) => {
  const classes = useStyles();
  return (
    <Box className={clsx(classes.root, type, scrollbar === false ? null : 'scrollbar')}>
      <CloseButton onClick={closeClick} />
      <Box className='content'>{content}</Box>
    </Box>
  )
}


/**
 * 浮動視窗 多個
 * type：Popper 跟按鈕位置、Dialog 畫面正中
 * id：識別編號、無id為單視窗
 * content：內容
 * btn：按鈕
 * placement：顯示位置
 * scrollbar：true-開起捲軸、false-關閉捲軸
 */
export function PopPaperMulti({type, id, content, btn, placement, scrollbar}) {

  const dispatch = useDispatch();
  const popPaperStore = useSelector(popPaperSelect);
  const [open, setOpen] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const canBeOpen = open && Boolean(anchorEl);
  const popperId = canBeOpen ? id : undefined;


  React.useEffect(() => {
    if((id !== popPaperStore.id) && open) {
      setOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popPaperStore.id]);

  const onClick = (e) => {
    setAnchorEl(e.currentTarget);
    if(id === popPaperStore.id) {
      setOpen(false);
      dispatch(popPaperUpdate({id: null}));
    } else {
      setOpen(true);
      dispatch(popPaperUpdate({id: id}));
    }
  };

  const closeClick = () => {
    setOpen(false);
    dispatch(popPaperUpdate({id: null}));
  }


  return (
    <>

      <Box onClick={(e) => onClick(e)}>{btn}</Box>

      <Hidden mdDown>

        {
          type !== 'Dialog'
          ?
            <Popper
              id={popperId}
              open={open}
              anchorEl={anchorEl}
              transition
              placement={placement ? placement : 'bottom'}
              style={{ zIndex: 1200 }}
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Box mt={2}>
                    <ContentBox type='Popper' content={content} closeClick={closeClick} scrollbar={scrollbar} />
                  </Box>
                </Fade>
              )}
            </Popper>
          :
            <Dialog
              open={open}
              onClose={closeClick}
              maxWidth='xl'
              PaperProps={{
                style: {
                  borderRadius: 12,
                  overflow: 'unset',
                }
              }}
            >
              <ContentBox type='Dialog' content={content} closeClick={closeClick} scrollbar={scrollbar} />
            </Dialog>
        }

      </Hidden>

      <Hidden mdUp>
        <Drawer
          anchor='bottom'
          open={open}
          onClose={closeClick}
        >
          <ContentBox type='Drawer' content={content} closeClick={closeClick} />
        </Drawer>
      </Hidden>

    </>
  )

}